import MainContent from "../components/MainContent";
import Sidebar from "../components/Sidebar";

const Home = () => {
  return (
    <div className="container relative">
      <Sidebar />
      <MainContent />
    </div>
  );
};

export default Home;
